import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { StateList, StatesList } from './customers.model';
import { RootState } from 'store/reducers';

interface CustomerSliceState {
  statesList?: StatesList;
}

const initialState: CustomerSliceState = {
  statesList: []
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    updateStatesList: (state, { payload }: PayloadAction<StateList[]>) => {
      state.statesList = payload;
    }
  }
});

export const selectStates = (state: RootState) => state.rootReducer.customers.statesList;

export const { updateStatesList } = customersSlice.actions;

export default customersSlice.reducer;
